/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs'

const $nsid = 'app.bsky.unspecced.getTrendingTopics'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  viewer: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 25 }),
      10,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  topics: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<UnspeccedDefs.TrendingTopic>(
      (() => UnspeccedDefs.trendingTopic) as any,
    ),
  ),
  suggested: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<UnspeccedDefs.TrendingTopic>(
      (() => UnspeccedDefs.trendingTopic) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a list of trending topics */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
